export default "__VITE_ASSET__Ulx0_bRA__"